import React from 'react'

export default function FieldSelectField_InlineValueEmpty(props:any) {

    const placeholder = props.field.noValueOption ? props.field.noValueOptionLabel : props.field.placeholder

    const classes = Classes("ui5-field-dropdown-inline-editable min-w-125", props.className, {
        'ui5-txt-no-accent-default' : !props.field.noValueOption,
        'ui5-txt-default'           : !!props.field.noValueOption,
    })

    return (
        <React.Fragment>
            <div className={classes} onClick={props.onClick}>
                {/*{_.get(props.field.components, 'ValueIcon', false)}*/}
                {!!props.field.noValueOptionIcon &&
                    <div className={Classes("ui5-ico-15 m-r-8", props.field.noValueOptionIcon)}/>}
                {placeholder}
            </div>
            {props.children}
        </React.Fragment>
    )

}
